import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import OfflineDurationSettingComponent from '../components/generalSettingComponent';
import {UpdateAbortAlarmTime1,getAllOfflineDuration,UpdateLifeguardDefibrillatorCprText1, updateOfflineDuration,updateRegistrationHeader,updateRegistrationText,
    UpdateAboutApp, UpdateContact,UpdateSupport,UpdateFeedback,updateDistance, updateAutoApprovedUser, updateAutoApprovedUserTimeFunc,updateAutoApprovedUser1, updateAutoApprovedUserTimeFunc1,
    setDefaultAlarmDistanceFunc, setDefaultEquipmentDistanceFunc, autoDefaultEquipmentDistanceFunc, updateEquipmentConditionFunc} from '../action/generalSettingAction';

export class GeneralSettingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllOfflineDuration();
    }
    getSettings = () => {
        this.props.actions.getAllOfflineDuration(
            this.props.dispatch
        )
    }
    updateOfflineDuration = (value) =>{
        this.props.actions.updateOfflineDuration(
            value,
            this.props.dispatch
        )
    }
    updateRegistrationHeader = (value) =>{
        this.props.actions.updateRegistrationHeader(
            value,
            this.props.dispatch
        )
    }
    updateRegistrationText = (value) =>{
        this.props.actions.updateRegistrationText(
            value,
            this.props.dispatch
        )
    }
    updateAboutSetting = (value) =>{
        this.props.actions.UpdateAboutApp(
            value,
            this.props.dispatch
        )
    }
    updateContactSetting = (value) =>{
        this.props.actions.UpdateContact(
            value,
            this.props.dispatch
        )
    }
    updateFeedbackSetting =(value) =>{
        this.props.actions.UpdateFeedback(
            value,
            this.props.dispatch
        )
    }
    updateSupportSetting =(value) =>{
        this.props.actions.UpdateSupport(
            value,
            this.props.dispatch
        )
    }
    updateDistanceForArrivedDetection = (value) =>{
        this.props.actions.updateDistance(
            value,
            this.props.dispatch
        )
    }
    updateAutoApprovedUser = (value) => {
        this.props.actions.updateAutoApprovedUser(
            value,
            this.props.dispatch
        )
    }
    updateAutoApprovedUserTime = (value) => {
        this.props.actions.updateAutoApprovedUserTimeFunc(
            value,
            this.props.dispatch
        )
    }
     updateAutoApprovedUser1 = (value) => {
        this.props.actions.updateAutoApprovedUser1(
            value,
            this.props.dispatch
        )
    }
    updateAutoApprovedUserTime1 = (value) => {
        this.props.actions.updateAutoApprovedUserTimeFunc1(
            value,
            this.props.dispatch
        )
    }
    updateDefaultEquipmentDistance = (value) => {
        this.props.actions.setDefaultEquipmentDistanceFunc(
            value,
            this.props.dispatch
        )
    }
    updateDefaultAlarmDistance = (value) => {
        this.props.actions.setDefaultAlarmDistanceFunc(
            value,
            this.props.dispatch
        )
    }
    updateAutoDefaultEquipmentDistance = (value) => {
        this.props.actions.autoDefaultEquipmentDistanceFunc(
            value,
            this.props.dispatch
        )
    }
    updateEquipmentCondition = (value) => {
        this.props.actions.updateEquipmentConditionFunc(
            value,
            this.props.dispatch
        )
    }
     UpdateLifeguardDefibrillatorCprText = (value) => {
        this.props.actions.UpdateLifeguardDefibrillatorCprText1(
            value,
            this.props.dispatch
        )
    }
     UpdateAbortAlarmTime = (value) => {
        this.props.actions.UpdateAbortAlarmTime1(
            value,
            this.props.dispatch
        )
    }
    render(){
        return(
            <div>
                <OfflineDurationSettingComponent
                    offlineDurationSetting = {this.props.offlineDurationSetting}
                    updateOfflineDuration = {this.updateOfflineDuration}
                    updateRegistrationHeader = {this.updateRegistrationHeader}
                    updateRegistrationText = {this.updateRegistrationText}
                    getAllSettings = {this.getSettings} 
                    UpdateLifeguardDefibrillatorCprText2={this.UpdateLifeguardDefibrillatorCprText}
                    updateAboutSetting = {this.updateAboutSetting}
                    updateContactSetting = {this.updateContactSetting}
                    updateFeedbackSetting = {this.updateFeedbackSetting}
                    updateSupportSetting = {this.updateSupportSetting}
                    updateAutoApprovedUser = {this.updateAutoApprovedUser}
                    updateAutoApprovedUserTime = {this.updateAutoApprovedUserTime}
                    updateDefaultEquipmentDistance = {this.updateDefaultEquipmentDistance}
                    updateAutoDefaultEquipmentDistance = {this.updateAutoDefaultEquipmentDistance}
                    updateEquipmentCondition = {this.updateEquipmentCondition}
                    updateDefaultAlarmDistance = {this.updateDefaultAlarmDistance}
                    updateDistanceForArrivedDetection = {this.updateDistanceForArrivedDetection}
                    UpdateAbortAlarmTimes={this.UpdateAbortAlarmTime}
                     updateAutoApprovedUser1 = {this.updateAutoApprovedUser1}
                    updateAutoApprovedUserTime1 = {this.updateAutoApprovedUserTime1}
                >
                </OfflineDurationSettingComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllOfflineDuration,
            updateOfflineDuration ,
            updateRegistrationHeader,
            updateRegistrationText,
            UpdateAboutApp,
            UpdateContact,
            UpdateSupport,
            UpdateFeedback,
            updateDistance,
            updateAutoApprovedUser,
            updateAutoApprovedUserTimeFunc,
            updateAutoApprovedUser1,
            updateAutoApprovedUserTimeFunc1,
            setDefaultAlarmDistanceFunc,
            setDefaultEquipmentDistanceFunc,
            autoDefaultEquipmentDistanceFunc,
            updateEquipmentConditionFunc,
            UpdateLifeguardDefibrillatorCprText1,
            UpdateAbortAlarmTime1
        },
            dispatch)
    };
}
function mapStateToProps({ generalSettingReducer }) { 
    return {
        offlineDurationSetting : {
            errorCode : generalSettingReducer.errorCode,
            statusCode : generalSettingReducer.statusCode,
            allSetting : generalSettingReducer.allSetting,
            message : generalSettingReducer.message,
            responseValue : generalSettingReducer.responseValue
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GeneralSettingContainer));
